import React, { Fragment } from "react";
import useI18n from "./hooks/useI18n.js";
import {
  selectIsConnectedToRoom,
  selectLocalVideoTrackID,
  selectVideoTrackByID,
  useAVToggle,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";
import {
  CameraFlipIcon,
  MicOffIcon,
  MicOnIcon,
  VideoOffIcon,
  VideoOnIcon,
} from "@100mslive/react-icons";
import { Tooltip } from "@100mslive/roomkit-react";
import { ToastManager } from "./Toast/ToastManager";
import IconButton from "../IconButton";
import { isMacOS } from "../common/constants";

export const AudioVideoToggle = () => {
  const { t } = useI18n("common");
  const { isLocalVideoEnabled, isLocalAudioEnabled, toggleAudio, toggleVideo } =
    useAVToggle();
  const actions = useHMSActions();
  const videoTracKId = useHMSStore(selectLocalVideoTrackID);
  const localVideoTrack = useHMSStore(selectVideoTrackByID(videoTracKId));
  const isConnectedToRoom = useHMSStore(selectIsConnectedToRoom);

  return (
    <Fragment>
      {toggleAudio ? (
        <Tooltip
          title={
            t(isLocalAudioEnabled ? "turn_off_audio" : "turn_on_audio") +
            ` (${isMacOS ? "⌘" : "ctrl"} + d)`
          }
        >
          <IconButton
            active={isLocalAudioEnabled}
            onClick={toggleAudio}
            key="toggleAudio"
            data-testid="audio_btn"
          >
            {!isLocalAudioEnabled ? (
              <MicOffIcon data-testid="audio_off_btn" />
            ) : (
              <MicOnIcon data-testid="audio_on_btn" />
            )}
          </IconButton>
        </Tooltip>
      ) : null}
      {toggleVideo ? (
        <Tooltip
          title={
            t(isLocalVideoEnabled ? "turn_off_video" : "turn_on_video") +
            ` (${isMacOS ? "⌘" : "ctrl"} + e)`
          }
        >
          <IconButton
            key="toggleVideo"
            active={isLocalVideoEnabled}
            onClick={toggleVideo}
            data-testid="video_btn"
          >
            {!isLocalVideoEnabled ? (
              <VideoOffIcon data-testid="video_off_btn" />
            ) : (
              <VideoOnIcon data-testid="video_on_btn" />
            )}
          </IconButton>
        </Tooltip>
      ) : null}
      {localVideoTrack?.facingMode && isConnectedToRoom ? (
        <Tooltip title={t("switch_camera")} key="switchCamera">
          <IconButton
            onClick={async () => {
              try {
                await actions.switchCamera();
              } catch (e) {
                ToastManager.addToast({
                  title:
                    t("error_flipping_camera") +
                    (e.message ? ` ${e.message}` : ""),
                  variant: "error",
                });
              }
            }}
          >
            <CameraFlipIcon />
          </IconButton>
        </Tooltip>
      ) : null}
    </Fragment>
  );
};
